module.exports = __webpack_public_path__ + "img/cloud-rain-lightning-sun.4fc9bfa6.svg";